import { deleteCookie, setCookie } from "cookies-next";

export const APP_LOGIN_COOKIE = "app_login";

export function setLoginCookie() {
  setCookie(APP_LOGIN_COOKIE, "true", {
    path: "/",
    sameSite: "lax",
    maxAge: 60 * 60 * 24 * 7, // 7 days
  });
}

export function clearLoginCookie() {
  deleteCookie(APP_LOGIN_COOKIE, { path: "/" });
}
